<template>
  <div class="label-preview">
    <header>
      <div class="p">P</div>
      <div class="head">
        <b-row class="up no-gutters">
          <b-col sm="4"><b>US POSTAGE</b></b-col>
          <b-col><img class="barcode" :src="'/images/barcode.png'" alt="barcode"></b-col>
        </b-row>
        <b-row class="down">
          <b-col sm="12"><b>Pitney Bowes</b></b-col>
          <b-col sm="12"><b>ComPlsPrice</b></b-col>
          <b-col sm="12"><span>NO SUPERCHARGE</span></b-col>
        </b-row>
      </div>
    </header>

    <section>
      <div class="title">
        LABEL LAYOUT PREVIEW
      </div>
      <b-row class="inner">
        <b-col sm="12" class="origin">
          <div v-if="origin.name">{{origin.name}}</div>
          <div v-else-if="origin.first_name || origin.last_name">{{origin.first_name}} {{origin.last_name}}</div>
          <div v-else-if="!origin.company" class="text-danger">Name</div>

          <div v-if="origin.company">{{origin.company}}</div>

          <div v-if="origin.address">{{origin.address}}</div>
          <div v-else class="text-danger">Origin Address Line 1</div>

          <div>
            <span v-if="origin.city">{{origin.city}}</span>
            <span v-else class="text-danger">City</span>

            <span v-if="origin.state">{{origin.state}}</span>
            <span v-else class="text-danger">State</span>

            <span v-if="origin.postal">{{origin.postal}}</span>
            <span v-else class="text-danger">Postal Code</span>
          </div>
        </b-col>

        <b-col sm="12" class="code">
          <span>C025</span>
        </b-col>

        <b-col sm="12" class="address">
          <div v-if="label.name">{{label.name}}</div>
          <div v-else-if="label.first_name || label.last_name">{{label.first_name}} {{label.last_name}}</div>
          <div v-else-if="!label.company" class="text-danger">Name</div>

          <div v-if="label.company">{{label.company}}</div>

          <div v-if="label.address">{{label.address}}</div>
          <div v-else class="text-danger">Address Line 1</div>

          <div v-if="label.address2">{{label.address2}}</div>

          <div>
            <span v-if="label.city">{{label.city}}</span>
            <span v-else class="text-danger">City</span>

            <span v-if="label.state">{{label.state}}</span>
            <span v-else class="text-danger">State</span>

            <span v-if="label.postal_code">{{label.postal_code}}</span>
            <span v-else class="text-danger">Postal Code</span>
          </div>

          <div v-if="label.country">{{label.country}}</div>
        </b-col>

        <div class="sticky-2">
          <span>{{ label.label_sticky_2 }}</span>
        </div>
      </b-row>
    </section>

    <footer>
      <div class="up">
        <span>USPS TRACKING #</span>
        <img class="barcode" :src="'/images/barcode.png'" alt="barcode">
        <span>9405 5098 9864 2313 9647 75</span>
      </div>
      <div class="down">
        <div>{{ label.label_sticky }}&nbsp;</div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      default: "Label Preview"
    },
    label: {
      default: {
        address: null
      }
    },
    origin: {
      default: () => ({})
    }
  },
  // watch: {
  //   label: function(newVal, oldVal) {
  //     console.log(newVal, oldVal);
  //   }
  // }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/LabelPreview.vue